import event from '@/api/modules/event/event'
const state = {
	data: null,
	ticketDialog: false,
	ticketData: {
		id: null,
		seat: null,
		person_info: {
			first_name: '',
			last_name: ''
		}
	}
}

const mutations = {
	TICKET_DIALOG_SHOW: (state) => {
		state.ticketDialog = true
	},
	TICKET_DIALOG_HIDE: (state) => {
		state.ticketDialog = false
	},
	TICKET_SET_DATA: (state, data) => {
		state.ticketData = data
	},
	SOCKET_SENT_TICKET: (state, _data) => {
		state.data = _data
	}
}

const actions = {
	socket_socketSentTicket: (context, message) => {
		let data = message[0]
		if (data.cancelled === 1) return false

		if (data.format === 'QR_CODE') {
			let ticketId = JSON.parse(data.result).ticket_id
			event.getOneById(ticketId).then((result) => {
				context.commit('TICKET_SET_DATA', result)
				context.commit('TICKET_DIALOG_SHOW', result)
			})
			let win = window.open('', '', 'toolbar=0,scrollbars=1,status=0')
			let win2 = window.open('', '', 'toolbar=0,scrollbars=1,status=0')
			setTimeout(() => {
				let html = document.getElementById('print-area')
				let bs = '<link href="https://fonts.googleapis.com/css?family=Roboto:400,700,900" rel="stylesheet">'
				win.document.write(bs)
				win.document.write(html.outerHTML)
				win2.document.write(bs)
				win2.document.write(html.outerHTML)
				setTimeout(() => {
					win.print()
					win.close()
					win2.print()
					win2.close()
				}, 300)
			}, 100)
		}
	},
	setTicketData: (context, data) => {
		context.commit('TICKET_SET_DATA', data)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/event.js